import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import DoctorList from "./consultant/doctorList";


const ScheduleAppointment = () => {
  let navigate = useNavigate();


  const onDrSelect = (val) => {
    console.log("dr", val);
    navigate(`/doctor/${val.id}`);
    // setCurrentDoctor(val); setShowHospList(true); setShowDrList(false);
  };





  return (
    <div className="bg-gray-50 min-sh-screen">
      <DoctorList handleDrSelect={onDrSelect} />
    </div>
  );
};

export default ScheduleAppointment;
